// Page titles and focus for in-app navigation (WCAG 2.4.2, 2.4.3, 2.4.1).
//
// Never move focus with a `#id` link: on /s/:id and /status/:id the
// fragment holds the key or sender token, and a skip link would replace it.

export const CONTENT_ID = 'content';

/** `<page> — <brand>`, or the brand's full title for the home page. */
export const formatPageTitle = (page: string | undefined, brand: string, home: string): string => (page ? `${page} — ${brand}` : home);

/**
 * Focus the page's main heading, or the content wrapper when there isn't
 * one yet (pages that are still loading). Headings get tabindex="-1" so
 * they can take focus without joining the tab order.
 */
export const focusContent = (doc: Document = document): void => {
  const content = doc.getElementById(CONTENT_ID);
  if (!content) return;
  const heading = content.querySelector<HTMLElement>('h1');
  const target = heading ?? content;
  if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
  target.focus({ preventScroll: false });
};
